import { OrderShipment } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { isValid } from 'date-fns';

// Backorder is confirmed with a valid ETA and is not delayed.
export const isBackOrderConfirmedWithEta = (shipment: OrderShipment): boolean => {
  if (!shipment.isBackOrder || shipment.status !== 'Confirmed') return false;

  const etaDate = new Date(shipment.shipmentEta || '');
  return isValid(etaDate) && !shipment.isDelayed;
};

// Back order is still "Confirmed" but the shipment is delayed.
export const isBackOrderEtaPassed = (shipment: OrderShipment): boolean => {
  if (!shipment.isBackOrder || shipment.status !== 'Confirmed') return false;

  const etaDate = new Date(shipment.shipmentEta || '');
  return isValid(etaDate) && shipment.isDelayed;
};

// Backorder has been received and is now in progress (Packed, Shipped, etc.).
export const isBackOrderReceived = (shipment: OrderShipment): boolean => {
  return shipment.isBackOrder && shipment.status !== 'Confirmed';
};

export const isShipmentDropShip = (shipment: OrderShipment): boolean => {
  return shipment.lineItems.some(li => li.isDropShip);
};
